import _ from 'lodash'
import {
  GA_KEY as DASHBOARD_KEY
} from '../Dashboard/OperatingDashboard/CustomerInterest/CustomerInterest.ga'
import {
  FIELD as TABLE_SORT_FIELD
} from '../Dashboard/OperatingDashboard/CustomerInterest/constants'
import {
  FIELD as TABLE_LINK_FIELD
} from '../Dashboard/OperatingDashboard/CustomerInterest/RankingTable/RankingTable'

export const GA_CLICK_ACTION = {
  TABLE_SORT: 'TABLE_SORT',
  TABLE_LINK: 'TABLE_LINK',
  EXPORT_EXCEL: 'EXPORT_EXCEL',
  TABLE_PAGINATION: 'TABLE_PAGINATION'
}

const COMMON_GA_KEYS = [
  DASHBOARD_KEY.TABLE_SORT_QUANTITY,
  DASHBOARD_KEY.TABLE_SORT_YESTERDAY_QUANTITY,
  DASHBOARD_KEY.TABLE_SORT_AMOUNT,
  DASHBOARD_KEY.TABLE_SORT_NOTIFY_QUANTITY,
  DASHBOARD_KEY.TABLE_SORT_TAG_QUANTITY,
  DASHBOARD_KEY.TABLE_LINK_ITEM_PRICE,
  DASHBOARD_KEY.TABLE_LINK_AVAILABLE_COUNT
]

const GA_KEY = {
  ..._.pick(DASHBOARD_KEY, COMMON_GA_KEYS),
  EXPORT_EXCEL: 'EXPORT_EXCEL',
  TABLE_PAGINATION: 'TABLE_PAGINATION'
}

const GA_KEY_MAP = {
  [GA_KEY.TABLE_SORT_QUANTITY]: 'abandoned_list_ordergd',
  [GA_KEY.TABLE_SORT_YESTERDAY_QUANTITY]: 'abandoned_list_yesterday',
  [GA_KEY.TABLE_SORT_AMOUNT]: 'abandoned_list_orderamt',
  [GA_KEY.TABLE_SORT_NOTIFY_QUANTITY]: 'abandoned_list_ordergd',
  [GA_KEY.TABLE_SORT_TAG_QUANTITY]: 'abandoned_list_ordergd',
  [GA_KEY.TABLE_LINK_ITEM_PRICE]: 'abandoned_list_currentprice',
  [GA_KEY.TABLE_LINK_AVAILABLE_COUNT]: 'abandoned_list_availcnt',
  [GA_KEY.EXPORT_EXCEL]: 'abandoned_list_downloadfile',
  [GA_KEY.TABLE_PAGINATION]: 'abandoned_list_pages'
}

export const getI13nModel = (action = {}, customizeI13nModel = {}) => {
  const { type, payload, statsType } = action
  // remove 'customerInterest' prefix and convert first letter to lower case
  const i13nPrefix = statsType.replace('customerInterest', '').replace(/^./, str => str.toLowerCase())
  let key
  switch (type) {
    case GA_CLICK_ACTION.TABLE_SORT: {
      const map = {
        [TABLE_SORT_FIELD.QUANTITY]: GA_KEY.TABLE_SORT_QUANTITY,
        [TABLE_SORT_FIELD.YESTERDAY_QUANTITY]: GA_KEY.TABLE_SORT_YESTERDAY_QUANTITY,
        [TABLE_SORT_FIELD.AMOUNT]: GA_KEY.TABLE_SORT_AMOUNT,
        [TABLE_SORT_FIELD.NOTIFY_QUANTITY]: GA_KEY.TABLE_SORT_TAG_QUANTITY,
        [TABLE_SORT_FIELD.TAG_QUANTITY]: GA_KEY.TABLE_SORT_TAG_QUANTITY
      }
      key = map[payload]
      break
    }
    case GA_CLICK_ACTION.TABLE_LINK: {
      const map = {
        [TABLE_LINK_FIELD.ITEM_PRICE]: GA_KEY.TABLE_LINK_ITEM_PRICE,
        [TABLE_LINK_FIELD.AVAILABLE_COUNT]: GA_KEY.TABLE_LINK_AVAILABLE_COUNT
      }
      key = map[payload]
      break
    }
    case GA_CLICK_ACTION.EXPORT_EXCEL:
    case GA_CLICK_ACTION.TABLE_PAGINATION:
      key = GA_KEY[type]
      break
    default:
      break
  }
  const i13nModel = {
    category: i13nPrefix,
    action: `${i13nPrefix}list`,
    label: GA_KEY_MAP[key].replace('abandoned_list', `${i13nPrefix}_list`),
    ...customizeI13nModel
  }
  return i13nModel
}
